import { NewsAnnouncementCategories } from '../news-announcement-categories';

export class NewsAnnouncement {
  category: NewsAnnouncementCategories;
  baseId: string;
  title: string;
  body: string;
}

export class NewsAnnouncementIds {
  [category: string]: string;

  constructor() {
    this[NewsAnnouncementCategories.AgencySpecific] = 'news-announcement-agency-specific';
    this[NewsAnnouncementCategories.GenericInformation] = 'news-announcement-generic-information';
    this[NewsAnnouncementCategories.ProblemsAndFixes] = 'news-announcement-problems-and-fixes';
    this[NewsAnnouncementCategories.PublicUser] = 'news-announcement-public-user';
    this[NewsAnnouncementCategories.RecentSystemUpdates] = 'news-announcement-recent-system-updates';
  }
}
